export const STATSIG_CLIENT_KEY =
    'client-Vp3Oe1HevIDVQ1ZmwKjt0AGx6HK1osdC2x4we07JVsU';

export const STATSIG_OVERRIDE_PARAM = 'overrideStatsig';
